import Vue from 'vue';
import Vuex from 'vuex';
import EventBus from './EventBus';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userAuthenticated: {},
    },
    mutations: {
        SET_USER_AUTH_STATE(state, payload) {
            state.userAuthenticated = payload;
            EventBus.$emit('UserAuthenticationStateChange');
            console.log('User Authentication State Updated');
        },
    },
    getters: {
        userAuthStatus: (state) => {
            return state.userAuthenticated;
        },
    },
    actions: {
        setUserAuthenticatedStatus({commit, state}, newValue) {
            commit('SET_USER_AUTH_STATE', newValue);
        },
    },
});
